export const portableTextComponentKeys = [
    "instagramEmbed",
    "youtubeEmbed",
    "tiktokEmbed",
    "quote",
    "twitterEmbed",
    "facebookEmbed",
    "twentythreeEmbed",
    "streamingProviders",
    "inlineImage",
    "table",
    "inlineGallery",
    "diceRow",
    "franchiseBlock",
    "inlineFilmList",
    "blueskyEmbed",
	"buttonLink"
];

export const markNoLinksKeys = [
    "streamingLink",
    "internalLink",
    "mailTo",
    "link"
];
